
<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: "App"
}
</script>

<style lang="scss">
// 项目公共样式
@import "@/assets/styles/public.scss";
@import "@/assets/styles/element-ui-reset.scss";

* {
  padding: 0;
  margin: 0;
  font-family: PingFangSC, PingFang SC;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  //color: #2c3e50;
}
</style>
